// extracted by mini-css-extract-plugin
export default {"checkbox":"style__checkbox--W6kEj"};